module.exports = __webpack_public_path__ + "static/media/logo.1964fe67.webp";